import Axios from "axios";

const AuthServices = {
  async login(params) {
    try {
      const res = await Axios.post("auth/login", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async readUserByToken(params) {
    try {
      const res = await Axios.post("auth/token", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async logout(params) {
    try {
      const res = await Axios.post("auth/logout", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
};

export default AuthServices;
